import { render } from "./FormMerchandise.vue?vue&type=template&id=14cbe464&ts=true"
import script from "./FormMerchandise.vue?vue&type=script&lang=ts"
export * from "./FormMerchandise.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__